import type {AppTopbarRef} from "../types";
import {forwardRef, useContext, useImperativeHandle, useRef, useState} from "react";
import AppBreadcrumb from "./AppBreadCrumb";
import {LayoutContext} from "./context/LayoutContext";
import {Avatar} from "primereact/avatar";
import {InputText} from "primereact/inputtext";
import GlobalSearch from "../components/GlobalSearch";
import {model} from "../config/menu-config";
// import {useNavigate} from "react-router-dom";

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
    const { onMenuToggle
        // , showProfileSidebar
        // , showConfigSidebar
    } =
        useContext(LayoutContext);
    // const navigate = useNavigate()
    const menubuttonRef = useRef(null);
    const [visible, setVisible] = useState(false);
    // const onConfigButtonClick = () => {
    //     showConfigSidebar();
    // };

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
    }));

    return (
        <div className="layout-topbar">
            <GlobalSearch visible={visible} setVisible={setVisible} menu={model}/>
            <div className="topbar-start">
                <button
                    ref={menubuttonRef}
                    type="button"
                    className="topbar-menubutton p-link p-trigger"
                    onClick={onMenuToggle}
                >
                    <i className="pi pi-bars"></i>
                </button>

                <AppBreadcrumb className="topbar-breadcrumb"></AppBreadcrumb>
            </div>

            <div className="topbar-end">
                <ul className="topbar-menu">
                    <li className="topbar-search" onClick={()=>setVisible(true)}>
                        <span className="p-input-icon-left">
                            <i className="pi pi-search"></i>
                            <InputText
                                readOnly
                                type="text"
                                placeholder="Ctrl K"
                                className="w-8rem"
                            />
                        </span>
                    </li>
                    {/*<li className="ml-3">*/}
                    {/*    <Button*/}
                    {/*        type="button"*/}
                    {/*        icon="pi pi-cog"*/}
                    {/*        text*/}
                    {/*        rounded*/}
                    {/*        severity="secondary"*/}
                    {/*        className="flex-shrink-0"*/}
                    {/*        onClick={onConfigButtonClick}*/}
                    {/*    ></Button>*/}
                    {/*</li>*/}
                    <li className="topbar-profile">
                        <button
                            // onClick={()=>navigate("/profile")}
                            type="button"
                            className="p-link"
                            // onClick={showProfileSidebar}
                        >
                          <Avatar icon={"pi pi-user"} shape="circle"  className={"bg-primary"} />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
});

AppTopbar.displayName = "AppTopbar";

export default AppTopbar;
